import { PageHeader } from '@/components/page-header';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Users } from 'lucide-react';

export function ResourcesPage() {
  return (
    <div className="space-y-6">
      <PageHeader 
        title="Resource Allocation" 
        description="Assign resources to projects with conflict detection"
      />

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Users className="h-5 w-5 text-purple-600" />
            Resource Management
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground">
            This feature is in preview. Enable Live Mode in Feature Labs to use with your real data.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
